import { render } from "./QcReviewPopup.vue?vue&type=template&id=0a7daf7d&scoped=true"
import script from "./QcReviewPopup.js?vue&type=script&lang=js"
export * from "./QcReviewPopup.js?vue&type=script&lang=js"

import "./QcReviewPopup.vue?vue&type=style&index=0&id=0a7daf7d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7daf7d"]])

export default __exports__